// The API sends two kinds of timestamps. Appointment `scheduled_at` is naive
// LOCAL wall-clock time (display as-is, never through here). Every other
// stamp (sent_at, confirmed_at, last_emailed_at, ...) is naive UTC with no
// "Z": `new Date(value)` would read it as browser-local time and show it 1-2 h
// early. These helpers read it as UTC and show it in the firm's zone, whatever
// the browser's zone is.

export const FIRM_TZ = 'Europe/Brussels';

const HAS_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

/** Date from a server timestamp; naive values are UTC. Invalid input -> null. */
export function parseUtc(value) {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (!value) return null;
  let s = String(value).trim().replace(' ', 'T');
  if (!s.includes('T')) s += 'T00:00:00';
  // Only a zone found after the time part counts: the "-10" of a date is not one.
  if (!HAS_ZONE.test(s.slice(s.indexOf('T')))) s += 'Z';
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

const locale = (lang) => ((lang || 'fr').startsWith('en') ? 'en-GB' : 'fr-BE');

/** Format a server timestamp in Europe/Brussels. '' when unparsable. */
export function formatBrussels(value, lang, options) {
  const d = parseUtc(value);
  if (!d) return '';
  return new Intl.DateTimeFormat(locale(lang), { timeZone: FIRM_TZ, ...options }).format(d);
}

export const formatShortDate = (value, lang) => formatBrussels(value, lang, { day: '2-digit', month: '2-digit' });
export const formatDate = (value, lang) => formatBrussels(value, lang, { day: '2-digit', month: '2-digit', year: 'numeric' });
export const formatDateTime = (value, lang) => formatBrussels(value, lang, { dateStyle: 'medium', timeStyle: 'short' });

/** Wall-clock parts in Europe/Brussels, or null. */
export function brusselsParts(value) {
  const d = parseUtc(value);
  if (!d) return null;
  const parts = {};
  new Intl.DateTimeFormat('en-GB', {
    timeZone: FIRM_TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(d).forEach((p) => { parts[p.type] = +p.value; });
  return { y: parts.year, mo: parts.month, d: parts.day, h: parts.hour, mi: parts.minute };
}
